export enum LocationDetailsHoldSortColumns {
	UNIT_ID = 'unitId',
	NAME = 'name',
	MODEL = 'model',
	NOTES = 'notes',
	REMOTE_PHONE = 'remotePhone',
	FILE_FORMAT = 'fileFormat'
}

export enum LocationDetailsVideoSortColumns {
	UNIT_ID = 'unitId',
	NAME = 'name',
	HOSTNAME = 'hostname',
	MODEL = 'model',
	NOTES = 'notes',
	LAST_UPDATE = 'lastUpdate',
	LAST_CHECKIN = 'lastCheckin'
}

export enum LocationDetailsRadioSortColumns {
	MAC_ADDRESS = 'macAddress',
	NAME = 'name',
	HOSTNAME = 'hostname',
	MODEL = 'model',
	NOTES = 'notes'
}
